<template>
  <div id="nav">
    <!-- <router-link to="/">Home</router-link> -->
  </div>
  <router-view />
  <footer>
    <div id="logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="70"
        height="25"
        viewBox="0 0 70 25"
      >
        <defs>
          <path
            id="logo_brut_header-a"
            fill="#000000"
            d="M0,1.59872116e-12 L10.8825911,1.59872116e-12 C13.4898785,1.59872116e-12 15.5020243,0.646648673 16.7773279,1.7431399 C18.1093117,2.92397661 18.7044534,4.38596491 18.7044534,6.26968061 C18.7044534,8.74381466 17.1740891,10.3182636 14.9068826,11.1054881 L14.9068826,11.2179487 C17.5991903,12.0051732 19.4412955,14.2262708 19.4412955,17.1783626 C19.4412955,19.4275753 18.7327935,21.0020243 17.2874494,22.2109762 C15.8987854,23.419928 13.7449393,24.122807 11.1659919,24.122807 L0,24.122807 L0,1.59872116e-12 Z M10.2874494,9.69973009 C12.4412955,9.69973009 13.8866397,8.68758435 13.8866397,6.80386865 C13.8866397,5.00449843 12.5546559,3.96423752 10.3724696,3.96423752 L4.93117409,3.96423752 L4.93117409,9.69973009 L10.2874494,9.69973009 Z M4.93117409,20.074224 L10.5991903,20.074224 C12.9797571,20.074224 14.3967611,18.7528115 14.3967611,16.8128655 C14.3967611,14.5074224 12.6963563,13.3265857 10.4574899,13.3265857 L4.93117409,13.3265857 L4.93117409,20.074224 Z M26.7530364,9.5591543 L26.8380567,9.5591543 C27.8866397,7.59109312 29.0769231,6.57894737 31.1174089,6.57894737 C31.6275304,6.57894737 31.9392713,6.60706253 32.194332,6.71952317 L32.194332,10.739991 L32.0809717,10.739991 C29.048583,10.4307242 26.8663968,12.0332883 26.8663968,15.6601439 L26.8663968,24.0946919 L22.2753036,24.0946919 L22.2753036,6.80386865 L26.7246964,6.80386865 L26.7246964,9.5591543 L26.7530364,9.5591543 Z M45.5708502,24.122807 L45.5708502,22.0985155 L45.4574899,22.0985155 C44.2672065,23.6729645 42.9068826,24.6007647 40.4696356,24.6007647 C36.5870445,24.6007647 34.4048583,22.1266307 34.4048583,18.3591993 L34.4048583,6.83198381 L39.0242915,6.83198381 L39.0242915,17.60009 C39.0242915,19.6243815 39.9311741,20.7489879 41.9149798,20.7489879 C44.097166,20.7489879 45.4291498,19.1183086 45.4291498,16.8409807 L45.4291498,6.80386865 L50.048583,6.80386865 L50.048583,24.122807 L45.5708502,24.122807 Z M52.3157895,6.80386865 L54.7246964,6.80386865 L54.7246964,1.40575798 L59.2591093,1.40575798 L59.2591093,6.80386865 L62.2631579,6.80386865 L62.2631579,9.84030589 L59.2591093,9.84030589 L59.2591093,19.005848 C59.2591093,20.2991453 59.9676113,20.7208727 60.9878543,20.7208727 C61.5546559,20.7208727 62.3481781,20.6927575 62.3481781,20.6927575 L62.3481781,24.0665767 C62.3481781,24.0665767 61.2995951,24.122807 59.4574899,24.122807 C57.2186235,24.122807 54.7246964,23.2512371 54.7246964,19.9617634 L54.7246964,9.84030589 L52.3157895,9.84030589 L52.3157895,6.80386865 Z M65.0404858,19.2307692 L70,19.2307692 L70,24.122807 L65.0404858,24.122807 L65.0404858,19.2307692 Z"
          />
        </defs>
        <g fill="none" fill-rule="evenodd">
          <mask id="logo_brut_header-b" fill="#fff">
            <use xlink:href="#logo_brut_header-a" />
          </mask>
          <use
            fill="#FFF"
            fill-rule="nonzero"
            xlink:href="#logo_brut_header-a"
          />
          <g fill="#2E3132" mask="url(#logo_brut_header-b)">
            <rect width="70" height="25" />
          </g>
        </g>
      </svg>
    </div>
    <p class="built">built with <Heart /> by</p>
    <p><a href="http://renaissancenft.net"><img class="rn-logo" src="@/assets/renaissance.svg" alt="Renaissance NFT"></a></p>
  </footer>
</template>


<script>
// @ is an alias to /src
import Heart from './components/Heart'
export default {
  components: {
    Heart
  },

}
</script>